import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './App';
import VoiceTrainer from './VoiceTrainer';
import registerServiceWorker from './registerServiceWorker';

/*
if (window.location.search === '?voicetrainer')
	ReactDOM.render(<VoiceTrainer />, document.getElementById('root'));
else
	ReactDOM.render(<App />, document.getElementById('root'));
*/

ReactDOM.render(<VoiceTrainer />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js